var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import pageMigrations from './pages';
import themeMigrations from './theme';
/**
* Version 1 migrations for the website.
* - Introduction of template page support.
* - Introduction of new text1 and text2 global theme elements.
*/
export default function v1(website) {
    return __assign(__assign({}, website), { frameworkVersion: 1, pages: pageMigrations(website.pages), theme: themeMigrations(website.theme) });
}
